export default __webpack_public_path__ + "static/media/hero_01.7bf977ac.png";